export default {
  computed: {
    headers () {
      return [
        {
          text: 'ID',
          value: 'id'
        },
        {
          text: 'Device',
          value: 'device',
          filtros: []
        },
        {
          text: 'Fingerprint',
          value: 'fingerprint',
          filtros: []
        },
        {
          text: 'UA',
          value: 'ua',
          width: '400px',
          filtros: []
        },
        {
          text: 'Arquitetura',
          value: 'arquitetura',
          filtros: []
        },
        {
          text: 'Browser',
          value: 'browser_nome',
          filtros: []
        },
        {
          text: 'SO',
          value: 'os_nome',
          filtros: []
        },
        {
          text: 'Chave',
          value: 'chave_liberacao',
          filtros: []
        },
        {
          text: 'Liberado',
          value: 'liberado',
          filtros: []
        }
      ]
    }
  }
}
